/*
 * @Author: your name
 * @Date: 2020-12-25 18:45:25
 * @LastEditTime: 2021-10-23 13:05:40
 * @LastEditors: DG
 * @Description: In User Settings Edit
 * @FilePath: /fe-ts-basic-platform/src/routers/Routes.js
 */
import React from 'react';
import Loadable from 'react-loadable';
import { Route, Switch, useLocation } from 'react-router-dom';
import { Skeleton } from 'antd';
import BasicLayout from '@/basic/Layout';
import { connect } from 'react-redux';
// import Loading from '@/components/Loading';
import { NoAuth, NoMatch, PageError } from '@/components/PageResult';
import FaqPage from 'pages/faq';
import { get } from 'lodash';
import routes from './index';

const modules = import.meta.glob('../pages/**/*.jsx');

const getAuth = (authList, access) => {
  if (!access) {
    return true;
  }
  return get(authList, access);
};

// 通用的loading组件
const loadingComponent = ({ error, timedOut, pastDelay }) => {
  if (error) {
    return <PageError error={error.message} />;
  }
  if (timedOut) {
    return <PageError error="页面加载超时" />;
  }
  if (pastDelay) {
    return <Skeleton active />;
  }
  return null;
};
const load = (filePath) =>
  Loadable({
    loader: () => {
      return modules[`../${filePath}/index.jsx`]().then((res) => res.default);
    },
    loading: loadingComponent,
    timeout: 10000,
  });

const Login = load('pages/login');
const Logout = load('pages/logout');

const generateRoute = (routes, currentStationInfo) => {
  return routes
    .map((r) => {
      const {
        routes: confRoutes,
        component,
        title,
        icon,
        path,
        access,
        conditions,
        ...restRouteProps
      } = r;
      if (!confRoutes && component) {
        if (
          conditions &&
          Object.keys(conditions).some((key) => currentStationInfo[key] !== conditions[key])
        )
          return null;
        // 不存在子路由 & 本身有加载路径
        const Component = load(component);
        // 路由一定会渲染，只是根据权限展示的内容不一定
        return <Route exact {...restRouteProps} key={path} path={path} component={Component} />;
      }
      return generateRoute(confRoutes, currentStationInfo);
    })
    .flat(Infinity);
};

// 查找 每一层 父节点菜单
function findAllParentNames(treeData, path, targetName) {
  for (let i = 0; i < treeData.length; i++) {
    const node = treeData[i];
    if (node.path === path) {
      targetName = node.title;
      return targetName;
    }
    if (node.routes && node.routes.length > 0) {
      const result = findAllParentNames(node.routes, path, targetName);
      if (result) return result;
    }
  }
  return null;
}

const Routes = React.memo((props) => {
  const { currentStationInfo } = props;
  const location = useLocation();

  // 监听路由变化，例如可以在路由变化时记录日志
  React.useEffect(() => {
    let title = findAllParentNames(routes, location.pathname);
    title = title ? '-' + title : '';
    document.title = `百川智多薪${title}`;
    if (location.pathname === '/site/salaryscheme') {
      document.title = '百川智多薪-计薪方案配置';
    }
  }, [location.pathname]);

  // const route = React.useMemo(() => {
  //   const len = Object.keys(authList).length;
  //   if (!len) {
  //     return [];
  //   }
  //   return generateRoute(routes, authList).concat(
  //     <Route key="/noMatch" path="*" component={NoMatch} />,
  //   );
  // }, [authList]);
  const route = generateRoute(routes, currentStationInfo).concat(
    <Route key="/faq" path="/faq" component={FaqPage} />,
    <Route exact key="/noAuth" path="/noAuth" component={NoAuth} />,
    <Route key="/noMatch" path="*" component={NoMatch} />,
  );

  return (
    <Switch>
      <Route exact path="/login/:return_url?" component={Login} />
      <Route exact path="/logout" component={Logout} />
      <BasicLayout>
        <Switch>{route}</Switch>
      </BasicLayout>
    </Switch>
  );
});
const mapStateToProps = (props) => {
  const {
    basic: { currentStationInfo },
  } = props;
  return { currentStationInfo };
};
export default connect(mapStateToProps)(Routes);
